module.exports = __webpack_public_path__ + "static/media/axios.c24a0163.jpg";